import { connect } from "react-redux";
import LicencesComponent from "../../Components/Licences/LicencesComponent";
import { setLicences } from "../../Redux/Actions/LicencesActions";
const mapStateToProps = (state) => ({
    LICENCES: state.reducer.LICENCES,
    SCOPES_NAMES : state.reducer.SCOPES_NAMES,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    });
const mapDispatchToProps = (dispatch) => ({
      setLicences: (LICENCES) => dispatch(setLicences(LICENCES)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(LicencesComponent);